import { render } from "./SupportRequestTable.vue?vue&type=template&id=1fb0e9e0&scoped=true&ts=true"
import script from "./SupportRequestTable.vue?vue&type=script&lang=ts"
export * from "./SupportRequestTable.vue?vue&type=script&lang=ts"

import "./SupportRequestTable.vue?vue&type=style&index=0&id=1fb0e9e0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb0e9e0"]])

export default __exports__